<template>
  <span id="enviar-email" v-show="cliente.plano.pago == true">
      <button type="button" class="btn btn-default btn-xs btn-block"
              @click="abrirModalConfirma">
        <i class="fa fa-envelope" aria-hidden="true" ></i>
        Enviar Email
      </button>
      <div class="modal fade" id="modal-enviar-email" tabindex="-1" role="dialog" aria-labelledby="" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h4 class="modal-title" id="">Enviar Email</h4>
            </div>
            <div class="modal-body">
              <!-- preparando para enviar -->
               <div class="" v-if="mostrarForm">
                   <div class="col-md-6">
                     Cliente: <b>{{cliente.name}}</b><br><br>
                   </div>
                   <div class="col-md-6">
                     E-mail: <b>{{cliente.email}}</b><br><br>
                   </div>
                   <div class="col-md-12">
                     <select v-model="emailPEnviar" class="form-control">
                       <option v-for="email in emails" :value="email.id" :disabled="email.disabled">
                         {{ email.nome }}
                       </option>
                     </select>
                   </div>
               </div>
               <!-- enviando -->
               <div class="text-center" v-if="enviando">
                 <br><br>
                 <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i><br><br>
                 <b>Enviado e-mail...</b>
                 <br><br>
               </div>
               <!-- enviado -->
                <div class="" v-if="enviado">
                  <br>
                  <h3 class="text-success text-center">
                    {{ msg }}
                  </h3>
                </div>
                <div class="row">
                  <br>
                </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-default" data-dismiss="modal" v-if="!enviando">
                <span v-if="enviado">Sair</span>
                <span v-else>Cancelar</span>
              </button>
              <button type="button" class="btn btn-primary" @click="enviarEmail"
                v-if="btnEnviar">
                <i class="fa fa-envelope" aria-hidden="true" ></i>
                >> Enviar
              </button>
            </div>
          </div>
        </div>
      </div>

    </span>
</template>
<script>
export default {
  name: "enviar-email",

  props: {
      cliente: {}
  },

  data(){
    return{
        msg : '',
        emails : [
          { id: null, nome: 'Selecione uma opção para enviar', disabled : true},
          { id: null, nome: 'Nenhuma das opções', disabled : false},
          { id: 1, nome: 'E-mail de Cobrança - Lembrete de Fatura', disabled : false},
          { id: 2, nome: 'E-mail de Liberação de Plano (enviar após liberação)', disabled: false}
        ],
        emailPEnviar : null, //tipo de email selecionado para ser enviado
        enviando : false,
        enviado : false
    }
  },

  methods: {

    abrirModalConfirma() {

        this.enviando = false
        this.enviado = false
        this.emailPEnviar = null
        this.msg = ''
        $('#modal-enviar-email').modal('show');
    },

    enviarEmail(){

      this.enviando = true
      let user =  _.clone(this.cliente)
      user.tipoemailenviar = this.emailPEnviar

      axios.post('api/enviar-email', user).then(({data}) => {
          this.msg = data
          console.log(data);
          this.enviando = false
          this.enviado = true
      }).catch((err) => {
          this.enviando = false
          this.enviado = false
      })

    }
  },

  computed:{
    btnEnviar(){

       if (this.enviando == true || this.enviado == true) {
         return false
       }else{
           if (this.emailPEnviar) {
             return true
           }
       }
    },
    mostrarForm(){
        if (this.enviando == true || this.enviado == true) {
          return false
        }else{
          return true
        }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
